/**
 * @generated SignedSource<<66e20f5e1ec592b0a25ca34ba35dba07>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useSideNavToggleStateQuery$data = {
  readonly navPlatSidebarData?: {
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "useSideNavToggleStateQuery";
};
export type useSideNavToggleStateQuery$key = {
  readonly " $data"?: useSideNavToggleStateQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSideNavToggleStateQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "navPlatSidebarDataEntityAri"
    },
    {
      "kind": "RootArgument",
      "name": "ownerAri"
    },
    {
      "kind": "RootArgument",
      "name": "skipNavPlatSidebarData"
    }
  ],
  "kind": "Fragment",
  "name": "useSideNavToggleStateQuery",
  "selections": [
    {
      "condition": "skipNavPlatSidebarData",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": "navPlatSidebarData",
          "args": [
            {
              "kind": "Variable",
              "name": "entityAri",
              "variableName": "navPlatSidebarDataEntityAri"
            },
            {
              "kind": "Variable",
              "name": "ownerAri",
              "variableName": "ownerAri"
            }
          ],
          "concreteType": "SettingsNavigationCustomisation",
          "kind": "LinkedField",
          "name": "settings_navigationCustomisation",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 20
                }
              ],
              "concreteType": "SettingsDisplayPropertyConnection",
              "kind": "LinkedField",
              "name": "properties",
              "plural": false,
              "selections": [
                {
                  "concreteType": "SettingsDisplayProperty",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "key"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "value"
                    }
                  ]
                }
              ],
              "storageKey": "properties(first:20)"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "10457a4b9b256497a957113768b1f14d";

export default node;
